import {Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Subject } from 'rxjs/Subject';
import {  Observable } from 'rxjs';
import { Translation } from "./translation.model";
import { TranslationType } from "./translationtype.model";
import { UIService } from '../shared/ui.service';

@Injectable()

export class TranslationService {
  transChanged = new Subject<Translation[]>();
  transTypeChanged = new Subject<TranslationType[]>();
  private availableTranslations: Translation[] = [];
  private availableTranslationTypes: TranslationType[] = [];
  public translationData: Translation;
  public dbupdate: boolean = false;


  constructor(private http: HttpClient, private router: Router, private uiservice : UIService ) {}

  form: FormGroup = new FormGroup({
    translationId: new FormControl(null),
    original: new FormControl('' , Validators.required),
    translated: new FormControl(''),
    translationTypeId: new FormControl(null, Validators.required),
    ignore:new FormControl(false)

  })

  initializeForm() {
    this.form.setValue(
      {
        translationId: null,
        original: '',
        translated: '',
        translationTypeId: null,
        ignore : false
      });
  }

  getTranslations(): Observable<Translation[]> {
    return this.http.get<Translation[]>('/api/Translation/GetTranslations');
  }

  getTranslationTypes(): Observable<TranslationType[]> {
    return this.http.get<TranslationType[]>('/api/Translation/GetTranslationTypes');

  }

 fetchTranslations() {
   this.http.get<Translation[]>('/api/Translation/GetTranslations')
     .subscribe(result => {
       this.availableTranslations = result;
       this.transChanged.next([...this.availableTranslations]);
     });
  }

  fetchTranslationTypes() {
    this.http.get<TranslationType[]>('/api/Translation/GetTranslationTypes')
      .subscribe(result => {
        this.availableTranslationTypes = result;
        this.transTypeChanged.next([...this.availableTranslationTypes]);
      });
  }


  setAvailableTranslations(translations: Translation[]) {
    this.availableTranslations = translations;
  }
  getAvailableTranslations() {
    return this.availableTranslations.slice();
  }

  getAvailableTranslationTypes() {
    return this.availableTranslationTypes.slice();
  }

  getFiles() {
    this.uiservice.showSnackbar('FTP initiated', null, 3000, false);
    this.http.get<TranslationType[]>('/api/FileImport/')
      .subscribe(result => {
       
      });
  }

  onImportCSV() {
    this.uiservice.showSnackbar('CSV Import Started', null, 3000, false);
    this.http.get<TranslationType[]>('/api/FileImport/ImportCSV/')
      .subscribe(result => {
       
      });
  }

  onGDrive() {
    this.uiservice.showSnackbar('Google Drive Initiated Started', null, 3000, false);
    this.http.get<TranslationType[]>('/api/Drive/')
      .subscribe(result => {

      });
  }

  onProcessTranslation() {
    this.uiservice.showSnackbar('Translation Started', null, 3000, false);
    this.http.get<TranslationType[]>('/api/FileImport/ProcessTranslation/')
      .subscribe(result => {

      });
  }
  onGenerateAds(feedID : string) {
    this.uiservice.showSnackbar('Ad Generation Started', null, 3000, false);
    this.http.get<TranslationType[]>('/api/GenerateAds/' + feedID) 
      .subscribe(result => {

      });
  }

  addTranslation(translation: Translation) {
    if (translation.original != null )
    this.http.post<boolean>('/api/Translation/' , translation)
      .subscribe(
        result => {
          this.dbupdate = result;
          if (this.dbupdate) {
            this.uiservice.showSnackbar('New record added successfully', null, 3000, true);
           // this.fetchTranslations();
          }
          else {
            this.uiservice.showSnackbar('Record addition failed', null, 3000, false);
          }
        });
    //this.availableTranslations.push(translation);
    //this.transChanged.next([...this.availableTranslations]);
   
  }

  updateTranslaion(translation: Translation)  {
    this.http.put<boolean>('/api/Translation/' + translation.translationId, translation)
      .subscribe(
        result => {
          this.dbupdate = result;
          if (this.dbupdate) {
            this.uiservice.showSnackbar('Record updated successfully', null, 3000, true);
            //this.fetchTranslations();
          }
          else {
            this.uiservice.showSnackbar('Record update failed', null, 3000, false);
           }
        });
  }

  deleteTranslation(transID: number) {
    this.http.delete<boolean>('/api/Translation/' + transID)
      .subscribe(
        result => {
          this.dbupdate = result;
          if (this.dbupdate) {
            this.uiservice.showSnackbar('Record deleted successfully', null, 3000, true);
          }
          else {
            this.uiservice.showSnackbar('Record deletion failed', null, 3000, false);
          }
        });
  }
  populateForm(translation) {
    this.form.setValue(translation);
  }

  onCancel() {
    this.uiservice.showSnackbar('Record cancelled', null, 3000, true);
  }
}
